import { getReviews } from './get-reviews';

export const GooglePlacesService = {
    getReviews,
};
